import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const forEach = require('lodash/forEach');
const Moment = require('moment');

const ServerRequest = require('../../actions/request');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
import GenericTextInputModal from '../modal/GenericTextInputModal';

const propTypes = {
    user: PropTypes.object.isRequired
};

const defaultProps = {};

class AdminUserBanEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userStoreState: AdminGlobalUserStore.getState(),
            modalState: {
                ban: false,
                unban: false,
            }
        };

        this.onBanClick = this.onBanClick.bind(this);
        this.showBanModal = this.showBanModal.bind(this);
        this.hideBanModal = this.hideBanModal.bind(this);
        this.showUnbanModal = this.showUnbanModal.bind(this);
        this.hideUnbanModal = this.hideUnbanModal.bind(this);
        this.executeBan = this.executeBan.bind(this);
        this.renderBanModal = this.renderBanModal.bind(this);
        this.onLiftBanClick = this.onLiftBanClick.bind(this);
        this.executeUnban = this.executeUnban.bind(this);
        this.renderUnbanModal = this.renderUnbanModal.bind(this);
        this.getUserDescriptionString = this.getUserDescriptionString.bind(this);

        this.unsubscribes = [
        AdminGlobalUserStore.listen(this.onStoreChange.bind(this, 'userStoreState')),
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    onBanClick(e) {
        this.showBanModal();
    }

    showBanModal() {
        this.setState({ modalState: { ...this.state.modalState, ban: true } });
    }

    hideBanModal() {
        this.setState({ modalState: { ...this.state.modalState, ban: false } });
    }

    showUnbanModal() {
        this.setState({ modalState: { ...this.state.modalState, unban: true } });
    }

    hideUnbanModal() {
        this.setState({ modalState: { ...this.state.modalState, unban: false } });
    }

    executeBan(banMessage) {
        this.hideBanModal();

        const user_id = this.props.user.id;
        ServerRequest.makeRequest((`/authoring/user/${user_id}/ban`), 'POST', JSON.stringify({ banMessage: banMessage }))
        .then(function(res) {
            console.log("ban result:", res);
            AdminGlobalUserStore.updateUserBanHistory(user_id);
            return null;
        })
        .catch(function(err) {
            console.log("ban error", err);
            AdminGlobalUserStore.updateUserBanHistory(user_id);
        });
    }

    // get a user description to display for confirmation purposes
    getUserDescriptionString() {
        let user_description;
        if (this.props.user.first_name && this.props.user.last_name) {
            user_description = this.props.user.first_name + " " + this.props.user.last_name; // both
        }
        else {
            user_description = this.props.user.first_name || this.props.user.last_name; // one or the other
        }
        if (!user_description) {
            user_description = this.props.user.display_name; // not shown in our table
        }

        // append their email for further information
        user_description += " " + (this.props.user.email || this.props.user.third_party_email);
        return user_description;
    }

    renderBanModal() {
        if (!this.state.modalState.ban) {
            return null;
        }

        const user_id = this.props.user.id;
        const user_description = this.getUserDescriptionString();
        return (
            <GenericTextInputModal
                show
                title="Suspend User"
                messageText={`Are you sure you want to SUSPEND (BAN) ${user_description}?`}
                promptText="Please specify reason for suspension"
                placeholderText="I just felt like it."
                confirmButtonText="Ban"
                onClose={this.hideBanModal}
                onConfirm={this.executeBan}
                requireText
            />
        );
    }

    onLiftBanClick(e) {
        this.showUnbanModal();
    }

    executeUnban(liftMessage) {
        this.hideUnbanModal();

        const _user = this.props.user;
        const user_id = _user.id;
        const currentBan = find(_user.ban_history, { active: true });
        if (!currentBan) {
            return;
        }

        ServerRequest.makeRequest((`/authoring/user/${user_id}/unban`), 'POST',JSON.stringify({
            banId: currentBan.id,
            liftMessage:liftMessage
        }))
        .then(function(res) {
            console.log("unban result:",res);
            AdminGlobalUserStore.updateUserBanHistory(user_id);
            return null;
        })
        .catch(function(err) {
            console.log("unban error", err);
            AdminGlobalUserStore.updateUserBanHistory(user_id);
        });
    }

    renderUnbanModal() {
        if (!this.state.modalState.unban) {
            return null;
        }

        const user_id = this.props.user.id;
        const user_description = this.getUserDescriptionString();
        return (
            <GenericTextInputModal
                show
                title="Suspend User"
                messageText={`Are you sure you want to remove the suspension for ${user_description}?`}
                promptText="Please specify reason"
                placeholderText="I just felt like it."
                confirmButtonText="Remove Suspension"
                onClose={this.hideUnbanModal}
                onConfirm={this.executeUnban}
                requireText
            />
        );
    }

    render() {
        const _user = this.props.user;
        const currentBan = find(_user.ban_history, { active: true });
        var buttonElem;
        if (currentBan) {
            buttonElem =(
                <button className="btn btn-primary suspend-button" onClick={this.onLiftBanClick}>
                    Lift Suspension
                </button>
            )
        }
        else {
            buttonElem = (
                <button className="btn btn-primary suspend-button" onClick={this.onBanClick}>
                    Suspend (Ban) This User
                </button>
            );
        }

        let historyElems = [];
        var authors = this.state.userStoreState.authors;

        forEach(_user.ban_history, (elem, i) => {
            var banAdmin = find(authors,{id: elem.ban_admin_id});
            var banAdminName = banAdmin ? banAdmin.first_name : elem.ban_admin_id;
            historyElems.push(
                <li key={'ban_' + i}>{Moment(elem.ban_date).format('YYYY-MM-DD HH:mm:ss') + ' banned by ' + banAdminName + ' : ' + elem.ban_message}</li>
            );

            if (!elem.active) {
                var liftAdmin = find(authors,{id: elem.lift_admin_id});
                var liftAdminName = liftAdmin ? liftAdmin.first_name : elem.lift_admin_id;
                historyElems.push(
                    <li key={'lift_' + i}>{Moment(elem.lift_date).format('YYYY-MM-DD HH:mm:ss') + ' ban lifted by ' + liftAdminName + ' : ' + elem.lift_message}</li>
                );
            }
        });

        return (
            <div className="user-ban-details">
                <ul>
                    <h1>Suspension History</h1>
                    { historyElems.length ?
                        historyElems
                        :
                        <li><i>None</i></li>
                    }
                </ul>
                {buttonElem}
                {this.renderBanModal()}
                {this.renderUnbanModal()}
            </div>
        );
    }
}

AdminUserBanEditor.propTypes = propTypes;
AdminUserBanEditor.defaultProps = defaultProps;

export default AdminUserBanEditor;